webpackJsonp([66],{

/***/ 1309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_filters__ = __webpack_require__(278);




var cancelSale = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var cancelModel;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						cancelModel = {
							commentary: '',
							subsidiaryId: this.sale.idSubsidiary
						};
						_context.next = 3;
						return this.$http.patch('//pms.controlinn.com/api' + '/point/' + this.id + '/document', cancelModel);

					case 3:
						this.showNotification('La venta se anuló correctamente.', 'success');
						this.closeConfirm();
						this.goToBack();

					case 6:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function cancelSale() {
		return _ref.apply(this, arguments);
	};
}();

var downloadQuotation = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var id, serie, model, responseType, params, response, blob;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						id = this.id;
						serie = this.sale.serie + '-' + this.sale.number;
						model = { code: 'pdf' };
						responseType = 'blob';
						params = { documentId: id };
						_context2.next = 7;
						return this.$http.post('//pms.controlinn.com/api' + '/report/accountStatus', model, { params: params, responseType: responseType });

					case 7:
						response = _context2.sent;
						blob = helperMethods.generateBlob(response.data);

						helperMethods.showDownloadDialog(blob, serie, 'pdf');

					case 10:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function downloadQuotation() {
		return _ref2.apply(this, arguments);
	};
}();

var downloadSaleCategory = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var id, serie, model, responseType, response, blob;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						id = this.id;
						serie = this.sale.serie + '-' + this.sale.number;
						model = { code: 'pdf-categories' };
						responseType = 'blob';
						_context3.next = 6;
						return this.$http.post('//sales.japisale.com' + '/p/sale-documents/' + id + '/pdf', model, { responseType: responseType });

					case 6:
						response = _context3.sent;
						blob = helperMethods.generateBlob(response.data);

						helperMethods.showDownloadDialog(blob, serie, 'pdf');

					case 9:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function downloadSaleCategory() {
		return _ref3.apply(this, arguments);
	};
}();

var downloadSale = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var id, serie, model, responseType, response, blob;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						id = this.id;
						serie = this.sale.serie + '-' + this.sale.number;
						model = { code: 'pdf' };
						responseType = 'blob';
						_context4.next = 6;
						return this.$http.post('//sales.japisale.com' + '/p/sale-documents/' + id + '/pdf', model, { responseType: responseType });

					case 6:
						response = _context4.sent;
						blob = helperMethods.generateBlob(response.data);

						helperMethods.showDownloadDialog(blob, serie, 'pdf');

					case 9:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function downloadSale() {
		return _ref4.apply(this, arguments);
	};
}();

var downloadTicket = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
		var urlBase, query, serie, response, blob;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						urlBase = '//pms.controlinn.com/api' + '/report/command-preview';
						query = '?format=tabloid&recipe=html-with-browser-client&documentId=' + this.id;
						serie = this.sale.serie + '-' + this.sale.number;
						_context5.next = 5;
						return this.$http.post('' + urlBase + query);

					case 5:
						response = _context5.sent;
						blob = helperMethods.generateBlob(response.bodyText);

						helperMethods.showDownloadDialog(blob, serie, 'html');

					case 8:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this);
	}));

	return function downloadTicket() {
		return _ref5.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
		var _ref7, sale;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						_context6.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/point/' + this.id + '/document');

					case 2:
						_ref7 = _context6.sent;
						sale = _ref7.data;

						sale.data.customer.fullName = sale.data.customer.name + ' ' + sale.data.customer.lastname;
						sale.data.customer.documentType = sale.data.customer.flagTypePerson === 1 ? 'DNI' : 'RUC';
						sale.data.customer.documentNumber = sale.data.customer.flagTypePerson === 1 ? sale.data.customer.dni : sale.data.customer.ruc;
						sale.data.numDocument = sale.data.serie && sale.data.number ? sale.data.serie + '-' + sale.data.number : '';
						sale.data.sucursalName = sale.data.subsidiary ? sale.data.subsidiary.sucursalName : '';
						this.flagTaxes = sale.data.subsidiary && sale.data.subsidiary.flagTaxes;
						this.customer = sale.data.customer;
						this.rows = sale.data.details.map(function (row) {
							var newRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, row);
							newRow.productCode = row.product.code;
							newRow.productName = row.product.name;
							newRow.categoryName = row.product.category.name;
							return newRow;
						});
						this.sale = sale.data;

					case 13:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this);
	}));

	return function loadData() {
		return _ref6.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var helperMethods = __WEBPACK_IMPORTED_MODULE_4__shared_helper__["a" /* default */].methods;

function created() {
	this.loadData();
}

function closeConfirm() {
	this.dialog = false;
}

function goToBack() {
	this.$router.push({ name: 'sales-list' });
}

function openDownloadView(type) {
	var rucSubsidiary = this.sale.subsidiary.ruc;
	var typeDoc = this.sale.typeDocument.code === 'BOL' ? 'BB' : 'FF';
	var serie = this.sale.serie;
	var number = this.sale.number;
	var codeTaxes = this.sale.typeDocument.codeTaxes;
	var url = 'http://devfac.apprunn.com' + '/admin/download/' + rucSubsidiary + '/document/' + typeDoc + serie + '-' + number + '/typeDocument/' + codeTaxes + '/' + type;
	window.open(url, '_blank');
}

function saleFinished() {
	return this.sale.state.code !== 'FIN';
}

function showDownloadBtn() {
	var saleDocumentValid = this.sale.typeDocument.code === 'FAC' || this.sale.typeDocument.code === 'BOL';
	return this.flagTaxes && saleDocumentValid;
}

function symbol() {
	return this.sale.currencySymbol;
}

function isQuotation() {
	return this.sale.typeDocument.code === 'COT';
}

function data() {
	return {
		columns: [{ id: 1, name: 'Fecha' }, { id: 2, name: 'Cod. Producto' }, { id: 3, name: 'Categoría' }, { id: 4, name: 'Nombre Producto' }, { id: 5, name: 'Cant.' }, { id: 6, name: 'Precio Producto' }, { id: 7, name: 'Total' }],
		customer: {
			typePerson: {
				fullName: '',
				documentNumber: ''
			}
		},
		dialog: false,
		flagTaxes: 0,
		rows: [],
		sale: {
			localDate: {},
			payment: {},
			state: {},
			subsidiary: {},
			typeDocument: {},
			tip: {}
		}
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'sale-detail',
	components: {
		TableRun: __WEBPACK_IMPORTED_MODULE_3_table_run___default.a
	},
	computed: {
		isQuotation: isQuotation,
		showDownloadBtn: showDownloadBtn,
		saleFinished: saleFinished,
		symbol: symbol
	},
	created: created,
	data: data,
	filters: {
		currency: __WEBPACK_IMPORTED_MODULE_6__shared_filters__["a" /* currency */],
		parseDate: __WEBPACK_IMPORTED_MODULE_6__shared_filters__["b" /* parseDate */],
		round: __WEBPACK_IMPORTED_MODULE_6__shared_filters__["c" /* round */]
	},
	methods: {
		downloadSaleCategory: downloadSaleCategory,
		cancelSale: cancelSale,
		closeConfirm: closeConfirm,
		downloadSale: downloadSale,
		downloadTicket: downloadTicket,
		goToBack: goToBack,
		loadData: loadData,
		openDownloadView: openDownloadView,
		downloadQuotation: downloadQuotation
	},
	mixins: __WEBPACK_IMPORTED_MODULE_5__shared_mixins__["a" /* default */],
	props: {
		id: {
			required: true,
			type: [Number, String]
		}
	}
});

/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".bar-data[data-v-165158d5]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.1);box-shadow:0 2px 5px 0 rgba(0,0,0,.1);display:-webkit-box;display:-ms-flexbox;display:flex;height:48px;-ms-flex-pack:distribute;justify-content:space-around}.bar-data-item[data-v-165158d5]{border-right:1px solid #e2e2e2;-webkit-box-flex:1;-ms-flex:1 auto;flex:1 auto}.bar-data-item.no-border[data-v-165158d5],.bar-data-item[data-v-165158d5]:last-of-type{border-right:0}.bar-data-item p[data-v-165158d5]{color:#545e72;font-family:San Francisco Display Medium;font-size:14px;margin-bottom:0}.bar-data-item p span[data-v-165158d5]{color:#818181;font-family:San Francisco Display;font-size:14px;text-transform:capitalize}.bar-data .bar-icon[data-v-165158d5]{font-size:20px;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:20px}.footer-bar-title[data-v-165158d5]{color:#4a4a4a;font-family:San Francisco Display Bold}.footer-bar-title.blue[data-v-165158d5]{background-color:#fff!important;border-color:#fff!important;color:#545e72}.footer-bar-title.white[data-v-165158d5]{background-color:#545e72!important;border-color:#545e72!important;color:#fff}.footer-bar-grey[data-v-165158d5]{background-color:#dadada}.footer-bar-white[data-v-165158d5]{background-color:#fff}.footer-bar-blue[data-v-165158d5]{background-color:#545e72!important}.footer-bar-content[data-v-165158d5]{color:#242424;font-family:San Francisco Display Semi Bold}.btn-ticket[data-v-165158d5]{background-color:#00ca52!important}.btn-categories[data-v-165158d5]{background-color:red}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/sales/Detail.vue"],"names":[],"mappings":"AACA,2BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,sBAAwB,AACxB,8CAAmD,AAC3C,sCAA2C,AACnD,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,yBAA0B,AACtB,4BAA8B,CACnC,AACD,gCACI,+BAAgC,AAChC,mBAAoB,AAChB,gBAAiB,AACb,WAAa,CACxB,AAID,uFACM,cAAkB,CACvB,AACD,kCACM,cAAe,AACf,yCAA4C,AAC5C,eAAgB,AAChB,eAAmB,CACxB,AACD,uCACQ,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,yBAA2B,CAClC,AACD,qCACI,eAAgB,AAChB,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,UAAY,CACf,AACD,mCACE,cAAe,AACf,sCAA0C,CAC3C,AACD,wCACI,gCAAqC,AACrC,4BAAiC,AACjC,aAAe,CAClB,AACD,yCACI,mCAAqC,AACrC,+BAAiC,AACjC,UAAe,CAClB,AACD,kCACE,wBAA0B,CAC3B,AACD,mCACE,qBAA0B,CAC3B,AACD,kCACE,kCAAqC,CACtC,AACD,qCACE,cAAe,AACf,2CAA+C,CAChD,AACD,6BACE,kCAAqC,CACtC,AACD,iCACE,oBAAsB,CACvB","file":"Detail.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.bar-data[data-v-165158d5] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: white;\n  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 48px;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.bar-data-item[data-v-165158d5] {\n    border-right: 1px solid #e2e2e2;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 auto;\n            flex: 1 auto;\n}\n.bar-data-item[data-v-165158d5]:last-of-type {\n      border-right: 0px;\n}\n.bar-data-item.no-border[data-v-165158d5] {\n      border-right: 0px;\n}\n.bar-data-item p[data-v-165158d5] {\n      color: #545e72;\n      font-family: \"San Francisco Display Medium\";\n      font-size: 14px;\n      margin-bottom: 0px;\n}\n.bar-data-item p span[data-v-165158d5] {\n        color: #818181;\n        font-family: \"San Francisco Display\";\n        font-size: 14px;\n        text-transform: capitalize;\n}\n.bar-data .bar-icon[data-v-165158d5] {\n    font-size: 20px;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n    width: 20px;\n}\n.footer-bar-title[data-v-165158d5] {\n  color: #4a4a4a;\n  font-family: \"San Francisco Display Bold\";\n}\n.footer-bar-title.blue[data-v-165158d5] {\n    background-color: #ffffff !important;\n    border-color: #ffffff !important;\n    color: #545e72;\n}\n.footer-bar-title.white[data-v-165158d5] {\n    background-color: #545e72 !important;\n    border-color: #545e72 !important;\n    color: #ffffff;\n}\n.footer-bar-grey[data-v-165158d5] {\n  background-color: #dadada;\n}\n.footer-bar-white[data-v-165158d5] {\n  background-color: #ffffff;\n}\n.footer-bar-blue[data-v-165158d5] {\n  background-color: #545e72 !important;\n}\n.footer-bar-content[data-v-165158d5] {\n  color: #242424;\n  font-family: \"San Francisco Display Semi Bold\";\n}\n.btn-ticket[data-v-165158d5] {\n  background-color: #00ca52 !important;\n}\n.btn-categories[data-v-165158d5] {\n  background-color: red;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1460:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1375);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("15d4789c", content, true);

/***/ }),

/***/ 1590:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Datos de venta")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "text-xs-right": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-end": ""
    }
  }, [(_vm.isQuotation) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-right": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Imprimir Comanda'
      }),
      expression: "{ html: 'Imprimir Comanda' }",
      arg: "left"
    }],
    staticClass: "mr-2 btn-ticket",
    attrs: {
      "dark": "",
      "fab": "",
      "icon": "",
      "small": "",
      "info": ""
    },
    on: {
      "click": _vm.downloadTicket
    }
  }, [_c('v-icon', [_vm._v("cloud_download")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.sale.typeDocument.name !== 'COTIZACION') ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-right": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Descargar Venta'
      }),
      expression: "{ html: 'Descargar Venta' }",
      arg: "left"
    }],
    staticClass: "mr-2",
    attrs: {
      "dark": "",
      "fab": "",
      "icon": "",
      "small": "",
      "info": ""
    },
    on: {
      "click": _vm.downloadSale
    }
  }, [_c('v-icon', [_vm._v("cloud_download")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.sale.typeDocument.name === 'COTIZACION') ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "pr-2": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Descargar Cotización'
      }),
      expression: "{ html: 'Descargar Cotización' }",
      arg: "left"
    }],
    staticClass: "mr-4",
    attrs: {
      "dark": "",
      "fab": "",
      "icon": "",
      "small": "",
      "info": ""
    },
    on: {
      "click": _vm.downloadQuotation
    }
  }, [_c('v-icon', [_vm._v("cloud_download")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.sale.typeDocument.name !== 'COTIZACION') ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-right": "",
      "pr-3": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Descargar Venta por Categorias'
      }),
      expression: "{ html: 'Descargar Venta por Categorias' }",
      arg: "left"
    }],
    staticClass: "mr-2",
    attrs: {
      "dark": "",
      "fab": "",
      "icon": "",
      "small": "",
      "warning": ""
    },
    on: {
      "click": _vm.downloadSaleCategory
    }
  }, [_c('v-icon', [_vm._v("donut_small")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showDownloadBtn) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-right": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-end": "",
      "pr-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "px-0": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Descargar ZIP'
      }),
      expression: "{ html: 'Descargar ZIP' }",
      arg: "left"
    }],
    attrs: {
      "dark": "",
      "fab": "",
      "icon": "",
      "warning": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.openDownloadView('zip')
      }
    }
  }, [_c('v-icon', [_vm._v("receipt")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showDownloadBtn) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "flex": "",
      "xs-2": "",
      "text-xs-right": "",
      "pr-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-end": "",
      "pr-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "px-0": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Descargar ZIP'
      }),
      expression: "{ html: 'Descargar ZIP' }",
      arg: "left"
    }],
    attrs: {
      "dark": "",
      "fab": "",
      "icon": "",
      "warning": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.openDownloadView('zip')
      }
    }
  }, [_c('v-icon', [_vm._v("receipt")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": ""
    }
  }, [_c('div', {
    staticClass: "bar-data"
  }, [_c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tNº Doc:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.sale.numDocument))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tSucursal:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.sale.sucursalName))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tCliente:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.customer.typePerson.fullName))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.customer.typePerson.documentName) + ":\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.customer.typePerson.documentNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tModo de pago:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.sale.payment.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tTipo de Doc:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.sale.typeDocument.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item no-border"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tFecha:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.sale.localDate.date)))])])])])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sale.commentary),
      expression: "sale.commentary"
    }],
    attrs: {
      "xs12": "",
      "mt-3": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Observación:")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset input-textarea input-note mt-2",
    attrs: {
      "no-resize": "",
      "multi-line": "",
      "rows": 2,
      "textarea": "",
      "readonly": "",
      "value": _vm.sale.commentary
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table mt-3",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "selectable": false,
      "include-search": false,
      "include-delete": false,
      "include-export-to-excel": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.createdAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.productCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.categoryName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.productName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.price), _vm.symbol)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.subTotal), _vm.symbol)))])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "px-1": "",
      "mb-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    staticClass: "footer-bar-grey",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "justify-center footer-bar-title"
  }, [_vm._v("\n\t\t\t\t\t\tCargo al Consumo\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "footer-bar-title"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(_vm.sale ? _vm.sale.tip : ''), _vm.symbol)))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-subheader', {
    staticClass: "footer-bar-title"
  }, [_vm._v("\n\t\t\t\t\t\t+\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "justify-center footer-bar-title"
  }, [_vm._v("\n\t\t\t\t\t\tSubtotal\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "footer-bar-content"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(_vm.sale.subtotal), _vm.symbol)))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-subheader', {
    staticClass: "footer-bar-title"
  }, [_vm._v("\n\t\t\t\t\t\t+\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "justify-center footer-bar-title"
  }, [_vm._v("\n\t\t\t\t\t\tIGV\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "footer-bar-content"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(_vm.sale.taxes), _vm.symbol)))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "footer-bar-white",
    attrs: {
      "xs5": ""
    }
  }, [_c('v-subheader', {
    staticClass: "justify-center footer-bar-title blue"
  }, [_vm._v("\n\t\t\t\t\t\t-dsct\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "footer-bar-content"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(_vm.sale.discount), _vm.symbol)))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "footer-bar-blue",
    attrs: {
      "xs7": ""
    }
  }, [_c('v-subheader', {
    staticClass: "justify-center footer-bar-title white"
  }, [_vm._v("\n\t\t\t\t\t\tTotal\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "footer-bar-title white"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(_vm.sale.amount), _vm.symbol)))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    on: {
      "click": _vm.goToBack
    }
  }, [_vm._v("\n\t\t\t\tRegresar\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t¿Desea anular la venta?\n\t\t\t")]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "btn-add btn-grey mr-2",
    nativeOn: {
      "click": function($event) {
        _vm.closeConfirm($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tCancelar\n\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-add",
    nativeOn: {
      "click": function($event) {
        _vm.cancelSale($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tAceptar\n\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1460)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1309),
  /* template */
  __webpack_require__(1590),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-165158d5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/66.43986c78fc2fb14097b8.js